import { all, takeEvery, put, call } from 'redux-saga/effects';
import ApiInstance from '../../../../../helpers/apiInstance';
import actions from './actions';
import { tableConfig } from '../../../../../settings/index';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import { executeAction } from '../../../../../helpers/api';

const api = new ApiInstance('units/:id/team_members');

function* load({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id } = payload;

    const result = yield call(
      sendRequest,
      api.get,
      { search: { page, pageSize, column, order, filter }, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200 && result.data) {
      const { records, totalCount, filteredCount, sortable_columns } = result.data;
      let data = records;

      if (records && records.length > 0) {
        data = records.map(record => {
          const { skills, ...rest } = record;

          return skills && skills.length > 1 ? { ...rest, children: skills } : record;
        });
      }

      yield put(
        actions.loadDataSuccess({
          data,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* sendActionRequest({ payload }) {
  try {
    const { url, method, cb } = payload;
    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      const { data } = result.data.success;
      yield put(cb({ data }));
    } else if (result?.status === 200) {
      yield put(cb({}));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, load), takeEvery(actions.SEND_REQUEST, sendActionRequest)]);
}
